import React, { Component, Fragment } from 'react';
import { Button, Modal } from 'reactstrap';
import classnames from 'classnames';
import RangeBillingInput from 'components/BillingForm/RangeBillingInput';
import buildPrice from 'helpers/buildPrice';

const BILLING_ANNUAL = '20%';
const BILLING_MONTH = '$9.00';
const PRICE_ANNUAL = '$87.00';

class BillingModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: !!props.trial,
    };

    this.toggle = this.toggle.bind(this);
  }

  state = {
    selectedPlan: 'annually',
  };

  changePlan = e => {
    return e
      ? this.setState({
          selectedPlan: e,
        })
      : null;
  };

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  }

  render() {
    const { changePlan, changeAccounts, accounts, period } = this.props;
    const { selectedPlan } = this.state;
    return (
      <Fragment>
        <div className="billing-link" onClick={this.toggle}>
          Change plan details
        </div>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className="delete-modal">
          <div className="delete-modal__content">
            <div className="h3-title delete-modal__title center">
              Change plan details
            </div>
            <div className="modal-range">
              <div className="modal-range__title">Number of domains</div>
              <RangeBillingInput
                rangeInputValue={accounts}
                handleChangeRange={changeAccounts}
              />
            </div>
            <div className="std-modal__row">
              <div className="text">Billing period</div>
            </div>
            <div className="std-modal__row">
              <div className="profile-card__select">
                <div
                  className={classnames('card-element-item', {
                    'card-element-item__checked': period === 'annually',
                  })}
                  onClick={() => changePlan('annually')}>
                  <div className="card-element-item__top">
                    <span className="heading">Billed Annually</span>
                    <span className="discount">-{BILLING_ANNUAL}</span>
                  </div>
                  <div className="card-element-item__bottom">
                    <span className="price">
                      $
                      {(buildPrice(accounts, 'annually') / accounts).toFixed(2)}
                    </span>
                    <span className="per">/year /domain</span>
                  </div>
                </div>
                <div
                  className={classnames('card-element-item', {
                    'card-element-item__checked': period === 'monthly',
                  })}
                  onClick={() => changePlan('monthly')}>
                  <div className="card-element-item__top">
                    <span className="heading">Billed Monthly</span>
                  </div>
                  <div className="card-element-item__bottom">
                    <span className="price">
                      ${(buildPrice(accounts, 'monthly') / accounts).toFixed(2)}
                    </span>
                    <span className="per">/month /domain</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="std-modal__row">
              <div className="text">
                <strong>New subscription total</strong>
              </div>
              <div className="price-value">${buildPrice(accounts, period)}</div>
            </div>
            <div className="separator-line" />
            <div className="delete-modal__btn">
              <Button
                color="blue"
                className="modal-btn-width"
                onClick={this.toggle}>
                Update
              </Button>
              <Button
                color="blue"
                className="outline modal-btn-width"
                onClick={this.toggle}>
                Cancel
              </Button>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}

export default BillingModal;



// WEBPACK FOOTER //
// ./src/components/BillingForm/BillingModal.js